import { apiGetInstallmentsReport } from "api/reportApi";
import Table from "components/Table";
import ContainedTabs from "components/Tabs/Tabs3";
import { installmentsShowTable } from "forms/InstallmentForm";
import { setQueryParam, setQueryParams } from "helpers/queryParam";
import { useEffect, useState } from "react";
import { store } from "store/store";

const InstallMentsReport = () => {
    const [active, setActive] = useState(0)
    const [activeTab, setActiveTab] = useState("installmentShow")
    const { dispatch, getState } = store
    const pagination = getState().paginationReducer
    useEffect(() => {
        setQueryParams([
            { key: "type", value: "receive" },
            { key: "status", value: "installmentShow" },
        ])

        return () => {

        }
    }, [])

    const InstallMentsReportUpperCompnent = () => {


        return <div className="flex gap-5">
            <ContainedTabs
                tabs={[
                    { label: "دریافتی", activeColor: "#1062D0" },
                    { label: "پرداختی", activeColor: "#1062D0" },
                ]}
                activeTab={active}
                centered={true}
                onChange={(val) => {
                    setQueryParams([
                        { key: "type", value: val === 0 ? "receive" : "payment" },
                        { key: "status", value: activeTab },
                    ])

                    dispatch(apiGetInstallmentsReport({ status: activeTab, type: val === 0 ? "receive" : "payment", filters: [], options: {}, pagination, search: {}, sort: {} }))
                    val !== undefined && setActive(val)
                }}
                size={1}
                minWidth={100}
            />
        </div>
    }
    return (
        <div className="warp-debtor-creaditor">
            <Table
                tabs={installmentsShowTable}
                onTabChange={(option) => {
                    setActiveTab(option.activeTab.key)
                    setQueryParams([
                        { key: "type", value: active === 0 ? "receive" : "payment" },
                        { key: "status", value: option.activeTab.key },
                    ])
                    dispatch(apiGetInstallmentsReport({ status: option.activeTab.apiKey, type: active === 0 ? "receive" : "payment", filters: [], options: {}, pagination, search: {}, sort: {} }))

                }}
                MidComponent={InstallMentsReportUpperCompnent as any} 
                sumAmountInfo={[
                    { name: "price",isCurrency:true, },
                    { name: "pay",isCurrency:true, },
                    { name: "remain",isCurrency:true, },
                    { name: "lateFees",isCurrency:true, },
                ]}
                />
        </div>
    );
}

export default InstallMentsReport;